import {IRouteDefinitionParams, IRuleset} from "../../../index";
import {global} from "../../../appContext";
import {nsRuleset} from "../nsRuleset";
import {IMutableRulesetParams} from "../mutable/mutableRuleset";
import {getRouteDefinition} from "../../../constants/RouteDefinitions";
import {nsFa} from "../../fa/fn";
import {ICreateRulesetEventParams, IUpdateRulesetEventParams} from "../index";
import pubsub from "../../../pubsub";
import {ObjectTypeId} from "../../../constants";
import {TabManager} from "../../tab-list/TabManager";
import {RequestRouteData} from "../../../req/RequestRouteData";
import i = nsFa.i;

export namespace nsRulesetVariableCrud {

    export type TCallback = (ruleset: IRuleset | null) => void

    export type TOperation = 'preview'
        | 'update'
        | 'read'
        | 'pick'
        | 'create'
        | 'remove'

    export function showDialog_create(callback: TCallback) {
        const routeDefParams: IMutableRulesetParams = {
            __dialog: {
                callbackFn: (ruleset: IRuleset) => {
                    nsRuleset.invalidateCachesAfterRulesetMutation()
                    const createEventParams: ICreateRulesetEventParams = {eventId: '', newRuleset: ruleset};
                    pubsub.trigger('ruleset.created', createEventParams)
                    callback?.(ruleset)
                },
                width: '95vw',
            },
            __routeDef: getRouteDefinition('createruleset', {
                showHeadingButtons: false,
                isDialog: true,
                objectTypeId: ObjectTypeId.User,
            })!,
            canChangeObjectType: false,
        }
        routeDefParams.__tabManager = new TabManager(routeDefParams)

        global.dialogManager.addCustom({
            name: 'component/ruleset/mutable/create',
            params: routeDefParams,
        })
    }

    export function showDialog_read(ruleset: IRuleset) {
        const routeDefParams: IRouteDefinitionParams = {
            __dialog: {
                width: '95vw',
            },
            __id: ruleset.id,
            __objectTypeId: ruleset.objecttype.id,
            __requestRouteData: new RequestRouteData(getRouteDefinition('rulesetdetails')!, {id: ruleset.id}),
            __routeDef: getRouteDefinition('rulesetdetails', {
                showHeadingButtons: false,
                showPageButtons: false,
                isDialog: true
            })!,
            __routeParams: {id: ruleset.id},
        }
        routeDefParams.__tabManager = new TabManager(routeDefParams)
        global.dialogManager.addCustom({
            name: 'component/ruleset/read/details',
            params: routeDefParams,
        })
    }

    export function showDialog_update(ruleset: IRuleset, callback: TCallback) {
        const routeDefParams: IMutableRulesetParams = {
            __dialog: {
                callbackFn: (newRuleset: IRuleset) => {
                    nsRuleset.invalidateCachesAfterRulesetMutation()
                    const updateEventParams: IUpdateRulesetEventParams = {
                        eventId: '',
                        oldRuleset: ruleset,
                        newRuleset: newRuleset
                    };
                    pubsub.trigger('ruleset.updated', updateEventParams)
                    callback(newRuleset)
                },
                width: '95vw',
            },
            __id: ruleset.id,
            __objectTypeId: ruleset.objecttype.id,
            __requestRouteData: new RequestRouteData(getRouteDefinition('editruleset')!, {id: ruleset.id}),
            __routeDef: getRouteDefinition('editruleset', {showHeadingButtons: false, isDialog: true})!,
            __routeParams: {id: ruleset.id},
            canChangeObjectType: false,
        }
        routeDefParams.__tabManager = new TabManager(routeDefParams)
        global.dialogManager.addCustom({
            name: 'component/ruleset/mutable/edit',
            params: routeDefParams,
        })
    }

    export function showDialog_pick(callback: TCallback, excludeObjectIds?: number[]) {
        const title = `${i('fa-hand-point-up')} ((choose subject|s:((ruleset|ac))))`
        _showDialog_pick(callback, title, excludeObjectIds)
    }

    export function showDialog_add(callback: TCallback, excludeObjectIds?: number[]) {
        const title = `${i('fa-hand-point-up')} ((add subject|s:((ruleset|ac))))`
        _showDialog_pick(callback, title, excludeObjectIds)
    }

    function _showDialog_pick(callback: TCallback, title: string, excludeObjectIds?: number[]) {
        global.dialogManager.addComponent({
            title: title,
            fullWidth: false,
            content: {
                name: 'component/ruleset/pick',
                params: {
                    __routeDef: getRouteDefinition('rulesetsearch', {
                        showHeadingButtons: false,
                        level: 2,
                    }),
                    excludeObjectIds,
                    selectedObject: callback,
                }
            }
        })
    }

    export function showDialog_preview(ruleset: IRuleset) {
        nsRuleset.fnPreviewRuleset(ruleset)
    }

}